import axios from "axios";
import {
  TokenValidationResponse,
  MagicTokenValidationResponse,
} from "../../model/auth-response";
interface ApiResponse {
  data: TokenValidationResponse;
}

export const doValidateTokenApiCall = async (
  token: string
): Promise<ApiResponse> => {
  return axios.get<TokenValidationResponse>("/api/auth/me", {
    headers: { "x-access-token": token },
  });
};

export const doMagicTokenCheckApiCall = async (
  magicToken: string
): Promise<{ data: MagicTokenValidationResponse }> => {
  return axios.post<MagicTokenValidationResponse>(
    "/api/auth/magic-token-check",
    {
      magicToken,
    }
  );
};
